<script>
    import { recaptchaService } from "@/core/RecaptchaService";

    export default {
        name: "GoogleRecaptcha",
        mounted() {
            recaptchaService.load((token) => {
                this.$emit("on-get-token", token);
            });
        },
        beforeDestroy() {
            recaptchaService.destroy();
        },
    };
</script>

<template>
    <div class="google-recaptcha" id="recaptcha_element" data-size="invisible"></div>
</template>

<style lang="scss">
    .google-recaptcha {
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
    }
</style>
